import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Observable, Observer, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { ConstantService } from './constant.service';
import { HelperService } from './helper.service';
import { catchError, map } from 'rxjs/operators';
import { environment } from "../../../environments/environment"
import { isPlatformBrowser, isPlatformServer } from
  '@angular/common';
@Injectable({
  providedIn: 'root'
})
export class AuthService {

  // private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.hasUser());

  // public get isLoggedIn() {
  //   return this.loggedIn.asObservable();
  // }

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;
  presentUser: any;
  // redirectUrl: string;
  constUrl = environment.APIBaseURL;


  constructor(private http: HttpClient,
    private constantSvc: ConstantService,
    private helperSvc: HelperService,
    private router: Router, @Inject(PLATFORM_ID) private platform: Object
  ) {
    if (isPlatformBrowser(this.platform)) {
      this.currentUserSubject = new BehaviorSubject<any>(this.helperSvc.ssGetItem('USER'));
      // console.log("current user subject", this.currentUserSubject.value);
      this.currentUser = this.currentUserSubject.asObservable();
    }
  }
  public get currentUserValue(): any {
    if (isPlatformBrowser(this.platform)) {

    this.presentUser = JSON.parse(sessionStorage.getItem('USER') || '{}');
    // console.log("current user value", this.currentUserSubject.value);
    return this.currentUserSubject.value;
    }
  }

  public get isLoggedIn_old() {
    return this.currentUser;
  }

  // private hasUser(): boolean {
  //   if (isPlatformBrowser(this.platform)) {

  //   return !!sessionStorage.getItem('USER');
  //   }
  // }

  login(url: any, data: any) {
    // this.spinner.show();
    // console.log("login function url", data);
    return this.http.post<any>(this.constUrl + url, data)
      .pipe(map(user => {
        // console.log("user", user);
        // if (user && user.status === 200) {
        // this.loggedIn.next(true);
          this.helperSvc.ssSetItem('USER', user);
          this.currentUserSubject.next(user);
        // this.spinner.hide();
        // }
        return user;
      }), catchError(error => {
        //handle specific errors
        // this.spinner.hide();
        console.log("error", error);
        if (error === 401) {
          // this.helperSvc.notifyError("An Active Profile was not Found!");
          //this.helperSvc.notifyError("Login Failed! An active profile was not found for this username and password.");
        }
        else if (error === 0) {
          //this.helperSvc.notifyError("Server Error");
        }
        return throwError(error.message || error);
      }))
  }

  private handleError(error: HttpErrorResponse) {
    console.log('in api error handler section ', error);
    // NProgress.done();
    return throwError('Server Error');
  }

  roleMatch(allowedRoles: any): boolean {
    var isMatch = false;
    if (isPlatformBrowser(this.platform)) {
      var userRoles: any = JSON.parse(sessionStorage.getItem('USER') || '{}');
      if (userRoles) {
        var roles = userRoles.user.role_id;
         //console.log("allowedRoles",allowedRoles);
         //console.log("roles",roles);
        if (allowedRoles === 1 && (roles == 1 || roles == 6)) {
          isMatch = true;
        }
      }
    }
    return isMatch;
  }

  logout() {
    // console.log("LOGOUT");
    this.helperSvc.ssRemoveItem('USER');
    // this.helperSvc.ssClear();
    // this.loggedIn.next(false);
    this.currentUserSubject.next(null);
    // this.helperSvc.notifySuccess('Session Destroyed Successfully!');
    // this.router.navigate(['/']);
    // this.router.navigate(['/logout']);
  }

  logout1() {
    this.helperSvc.ssRemoveItem('USER');
    // this.loggedIn.next(false);
    this.currentUserSubject.next(null);
    // this.helperSvc.notifySuccess('Session Destroyed Successfully!');
    // this.router.navigate(['/']);
    this.router.navigate(['/logout']);
  }


}
